
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foodies/[user_name]/dinners",
      function () {
        return require("private-next-pages/foodies/[user_name]/dinners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foodies/[user_name]/dinners"])
      });
    }
  